import { create } from 'zustand';

export interface AudioTrack {
  /** מקור ההקלטה (URL). זיהוי ייחודי של הטראק הנוכחי. */
  src: string;
  /** כותרת ראשית בסרגל (למשל "שיחה #123" או מספר טלפון). */
  title: string;
  /** שורת משנה אופציונלית (נציג / כיוון / משך). */
  subtitle?: string;
  /** משך ידוע מראש (שניות) — כשהמקור לא מדווח duration עד שנטען. */
  duration?: number;
}

interface AudioPlayerState {
  /** הטראק המתנגן כעת, או null כשהסרגל סגור. */
  track: AudioTrack | null;
  /** מתחיל השמעת טראק (מחליף טראק קודם אם יש). */
  play: (track: AudioTrack) => void;
  /** עוצר וסוגר את הסרגל. */
  close: () => void;
  /** מצב ההשמעה בפועל (לא רק "יש טראק") — הסרגל מעדכן; כפתורי ▶ במסכים קוראים. */
  playing: boolean;
  /** ההשמעה נכשלה (מקור לא זמין / חסימת autoplay). */
  failed: boolean;
  setStatus: (st: { playing: boolean; failed: boolean }) => void;
}

/**
 * מצב נגן ההקלטות הגלובלי. חי מחוץ ל-router (כמו הצ'אט הצף/הסופטפון) כך
 * שההשמעה שורדת סגירת drawer/sidebar וניווט בין דפים. הסרגל התחתון
 * (PersistentAudioBar) הוא הבעלים היחיד של אלמנט ה-<audio>; קומפוננטות
 * כמו AudioPlayer רק קוראות ל-play() ומעבירות את ההשמעה אליו.
 */
export const useAudioPlayer = create<AudioPlayerState>()((set) => ({
  track: null,
  playing: false,
  failed: false,
  play: (track) => set({ track, failed: false }),
  close: () => set({ track: null, playing: false, failed: false }),
  setStatus: ({ playing, failed }) => set({ playing, failed }),
}));
